<script lang="ts" setup>
import { ref, onMounted, nextTick } from 'vue';

import FloatNavigator from '@@home/components/FloatNavigator.vue';
import FloatNavigatorItem from '@@home/components/FloatNavigatorItem.vue';

import WelfareDonate from './components/WelfareDonate.vue';
import Partner from './components/Partner.vue';
import ProjectDonate from './components/ProjectDonate.vue';

const navigatorEl = ref<any>(null);

const props = defineProps({
  navigator: {
    type: String,
    default: ''
  }
});

onMounted(async () => {
  if (props.navigator === 'partner') {
    await nextTick();
    navigatorEl.value.goto(2);
  }
});
</script>

<template>
  <main class="page-cooperation">
    <section class="cooperation-title bg-cover bg-center bg-no-repeat">
      <div class="cooperation-title__container mx-auto w-[1360px] <2xl:w-1200px">
        <h1 class="m-0 font-medium">
          <span>{{ $t('cooperation.title') }}</span>
          <small class="align-middle font-medium">{{ $t('cooperation.titleSmall') }}</small>
        </h1>
        <p class="m-0">
          {{ $t('cooperation.titleDescription') }}
        </p>
      </div>
    </section>

    <FloatNavigator bar-class="w-[1360px] mx-auto <2xl:w-1200px" ref="navigatorEl">
      <FloatNavigatorItem :label="$t('cooperation.navigator1')">
        <WelfareDonate />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('cooperation.navigator2')">
        <ProjectDonate />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('cooperation.navigator3')">
        <Partner />
      </FloatNavigatorItem>
    </FloatNavigator>
  </main>
</template>

<style lang="scss" scoped>
.page-cooperation {
  padding-bottom: 80px;
  color: #2d2d2d;

  .cooperation-title {
    min-height: 400px;
    background-color: #f7f9f9;
    background-image: url(@@home/assets/cooperation/title-bg.jpg);

    .cooperation-title__container {
      @apply pt-125px pb-0 <2xl:pb-80px;

      h1 {
        font-size: 50px;

        span {
          line-height: 70px;
        }

        small {
          margin-left: 24px;
          font-size: 24px;
          line-height: 36px;
        }
      }

      p {
        margin-top: 10px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
</style>
